import type {
    DesignSystemCardDirection,
    DesignSystemCardSize,
} from '../../theme/design-system/types';

export const DEFAULT_CARD_SIZE: DesignSystemCardSize = 'sm';
export const DEFAULT_CARD_DIRECTION: DesignSystemCardDirection = 'vertical';
